import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "survey-core/survey.i18n";


let appConfig = document.getElementById('wink-online-module')?.dataset;
ReactDOM.render(
  <React.StrictMode>
    <App {...appConfig} />
  </React.StrictMode>,
  document.getElementById('wink-online-module')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
